import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["mapContainer"]
  static values = {
    fieldId: String,
    address: String,
    latitude: String,
    longitude: String
  }

  connect() {
    // Guardar referencia global para uso en funciones sin Stimulus
    window.mapSelectorControllerPaciente = this

    // Inicializar Google Map
    this.initializeMap()
    this.setupEventListeners()
  }

  initializeMap() {
    if (!window.google || !window.google.maps) {
      console.warn("[map-selector-paciente] Google Maps API no está cargado aún")
      return
    }

    const defaultLatLng = { lat: -32.94, lng: -60.63 } // Argentina (centro aproximado)
    
    this.map = new google.maps.Map(this.mapContainerTarget, {
      zoom: 13,
      center: defaultLatLng,
      mapTypeControl: true,
      fullscreenControl: true,
      streetViewControl: false,
      zoomControl: true,
      mapTypeId: google.maps.MapTypeId.ROADMAP
    })

    // Crear marcador arrastrable
    this.marker = new google.maps.Marker({
      position: defaultLatLng,
      map: this.map,
      draggable: true,
      title: "Tu domicilio"
    })

    // Event listeners del marcador
    this.marker.addListener("dragend", () => this.updateMarkerPosition())
    this.map.addListener("click", (e) => {
      this.marker.setPosition(e.latLng)
      this.updateMarkerPosition()
    })

    // Setup para buscar direcciones
    this.setupAddressSearch()
  }

  setupAddressSearch() {
    const addressInput = document.getElementById("address-input-paciente")
    if (!addressInput) return

    const autocomplete = new google.maps.places.Autocomplete(addressInput, {
      types: ["address"],
      componentRestrictions: { country: "ar" }
    })

    autocomplete.addListener("place_changed", () => {
      const place = autocomplete.getPlace()
      if (place.geometry && place.geometry.location) {
        this.map.setCenter(place.geometry.location)
        this.marker.setPosition(place.geometry.location)
        this.updateMarkerPosition()
      }
    })
  }

  setupEventListeners() {
    const confirmBtn = document.getElementById("confirm-location-btn-paciente")
    if (confirmBtn) {
      confirmBtn.addEventListener("click", () => this.confirmLocation())
    }
  }

  updateMarkerPosition() {
    const position = this.marker.getPosition()
    const lat = position.lat().toFixed(6)
    const lng = position.lng().toFixed(6)
    
    // Actualizar coordenadas en el display
    const coordsDisplay = document.getElementById("coords-display-paciente")
    if (coordsDisplay) {
      coordsDisplay.textContent = `${lat}, ${lng}`
    }

    // Guardar en atributo del modal para uso posterior
    const modal = document.getElementById("map-modal-wrapper-paciente")
    if (modal) {
      modal.dataset.mapSelectorPacienteLatitude = lat
      modal.dataset.mapSelectorPacienteLongitude = lng
    }
  }

  confirmLocation() {
    const position = this.marker.getPosition()
    const lat = position.lat().toFixed(6)
    const lng = position.lng().toFixed(6)
    const geoCode = `${lat},${lng}`

    // Guardar en el campo oculto
    const field = document.getElementById("paciente_geo_code")
    if (field) {
      field.value = geoCode
      // Disparar evento de cambio para que otros controladores se enteren
      field.dispatchEvent(new Event('change', { bubbles: true }))
    }

    // Cerrar modal
    closeMapModalPaciente()
  }

  // Métodos públicos para ser llamados desde funciones globales
  centerOnAddress(fullAddress, cityName, street, number, latitude, longitude) {
    // Si tenemos coordenadas exactas, usarlas
    if (latitude && longitude) {
      const latNum = parseFloat(latitude)
      const lngNum = parseFloat(longitude)
      if (!isNaN(latNum) && !isNaN(lngNum)) {
        const location = { lat: latNum, lng: lngNum }
        this.map.setCenter(location)
        this.map.setZoom(16)
        this.marker.setPosition(location)
        this.updateMarkerPosition()
        return
      }
    }

    // Intentar geocodificar con dirección completa
    if (fullAddress && fullAddress.trim()) {
      const geocoder = new google.maps.Geocoder()
      geocoder.geocode({ address: fullAddress, componentRestrictions: { country: 'AR' } }, (results, status) => {
        if (status === google.maps.GeocoderStatus.OK && results[0]) {
          const location = results[0].geometry.location
          this.map.setCenter(location)
          this.map.setZoom(16)
          this.marker.setPosition(location)
          this.updateMarkerPosition()
          return
        }

        // Fallback: geocodificar solo la ciudad
        if (cityName && cityName.trim()) {
          this.centerOnCity(cityName)
        }
      })
      return
    }

    // Último fallback: solo ciudad
    if (cityName && cityName.trim()) {
      this.centerOnCity(cityName)
    }
  }

  centerOnCity(cityName) {
    const geocoder = new google.maps.Geocoder()
    geocoder.geocode({ address: cityName + ', Argentina', componentRestrictions: { country: 'AR' } }, (results, status) => {
      if (status === google.maps.GeocoderStatus.OK && results[0]) {
        const location = results[0].geometry.location
        this.map.setCenter(location)
        this.map.setZoom(13)
        this.marker.setPosition(location)
        this.updateMarkerPosition()
      }
    })
  }

  disconnect() {
    // Limpiar referencia global
    if (window.mapSelectorControllerPaciente === this) {
      delete window.mapSelectorControllerPaciente
    }
  }
}
